/* eslint-disable */
import React, {
  useState,
  useContext,
  useEffect,
  useMemo,
  useRef,
} from "react";
import ReactDOM from "react-dom";
// material react table
import { MaterialReactTable } from "material-react-table";
import * as XLSX from "xlsx";
//import translation function for language translation
import { useTranslation } from "react-i18next";
import useMRTLocalization from "hooks/useMRTLocalization";

/*import url and gateway methods */
import { postData, getData, putData } from "utils/Gateway";
import * as url from "urlhelpers/UrlHelper";

//import context
import { GlobalProvider } from "context/GlobalContext";
import { Link } from "react-router-dom";
import SurveyHeader from "./Header/SurveyHeader";
import SurveyBreadCrumb from "./BreadCrumb/SurveyBreadCrumb";

const SurveyListArea = () => {
  const { t } = useTranslation(); //for translation
  const mrtLocalization = useMRTLocalization();

  const token = localStorage.getItem("token"); //import token

  const {
    reloadSurveyList,
    setReloadSurveyList,
    setEditSurveyData,
    screenHeight,
  } = useContext(GlobalProvider);

  //use state for survey list
  const [surveyList, setSurveyList] = useState([]);
  const [responseReceived, setResponseReceived] = useState(false);
  const [rowSelection, setRowSelection] = useState({});

  /* useState hook to download excel file */
  const [downloadExcel, setDownloadExcel] = useState(false);
  /* hook to get number of records */
  const [records, setRecords] = useState(0);

  const blockRefSelected = useRef(null);

  /* function for checking record count */
  const updateSelectedCount = (selectCount) => {
    const blockElementSelect = ReactDOM.findDOMNode(blockRefSelected.current);
    if (blockElementSelect) {
      blockElementSelect.innerHTML = selectCount;
    }
  };

  const getSelectedData = () => {
    const selectedIds = Object.keys(rowSelection).filter((key) => rowSelection[key]);
    return surveyList.filter((item) => selectedIds.includes(item._id));
  };

  /* Excel export */
  const exportExcel = () => {
    const selectedData = getSelectedData();
    const exportData = selectedData.length > 0 ? selectedData : surveyList;
    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, "Survey.xlsx");
  };

  //function for get survey list
  const getAllSurvey = async () => {
    try {
      let requestUrl =
        url.API_BASEURL + url.API_GET_ALL_SURVEY + `?token=${token}`;

      console.log("survey list url =====>>>", requestUrl);

      const response = await getData(requestUrl);

      console.log("survey list response ========>>>", response);

      if (response.data) {
        setSurveyList(response.data);
        setResponseReceived(true);
        setRecords(response.data.length);
      }
    } catch (error) {
      console.error(error.message);
    }
  };

  /* custom name html */
  const nameHTML = ({ dataItem }) => {
    return (
      <div className="kendoCustomColumn overflow-visible">
        <div className="d-flex align-items-center gap-2">
          <p className="d-flex gap-2 align-items-center text-nowrap">
            <span className="d-block">{dataItem.name.slice(0, 35)}</span>
          </p>

          <Link
            className="ml-auto edit_icon"
            type="button"
            to="#saveSurveyPopup"
            data-bs-toggle="offcanvas"
            aria-expanded="false"
            data-bs-placement="top"
            title="Edit Survey"
          >
            <span
              className="d-block material-symbols-outlined icon-md"
              onClick={() => {
                setEditSurveyData(dataItem);
              }}
            >
              edit
            </span>
          </Link>

          <Link
            to={"/feedbackresponses/" + dataItem._id}
            className="text-gray-700 bg-transparent border-0"
            data-bs-placement="top"
            title="Feedback Responses"
          >
            <span className="d-block material-symbols-outlined icon-md">
              forum
            </span>
          </Link>
        </div>
      </div>
    );
  };

  /* hook to hit exportExcel() function*/
  useEffect(() => {
    downloadExcel && exportExcel();
  }, [downloadExcel]);

  useEffect(() => {
    if (responseReceived === false) {
      getAllSurvey();
    }
  }, [responseReceived]);

  useEffect(() => {
    if (reloadSurveyList) {
      getAllSurvey();
      setReloadSurveyList(false);
    }
  }, [reloadSurveyList]);

  /* set records when surveyList changes */
  useEffect(() => {
    setRecords(surveyList.length);
  }, [surveyList]);

  /* sync selected count to DOM ref */
  useEffect(() => {
    const selectedCount = Object.keys(rowSelection).filter((key) => rowSelection[key]).length;
    updateSelectedCount(selectedCount);
  }, [rowSelection, surveyList]);

  const tableColumns = useMemo(
    () => [
      {
        id: "name",
        accessorKey: "name",
        header: t("Title"),
        Cell: ({ row }) => nameHTML({ dataItem: row.original }),
        filterFn: "includesString",
        size: 400,
        muiTableBodyCellProps: {
          sx: { overflow: "visible", position: "static" },
        },
      },
      {
        id: "code",
        accessorKey: "code",
        header: t("Code"),
        size: 200,
      },
      {
        id: "feedbackcount",
        accessorKey: "feedbackcount",
        header: t("Feedback Count"),
        size: 200,
      },
      {
        id: "surveydate",
        accessorKey: "surveydate",
        header: t("Date"),
        size: 200,
      },
    ],
    [surveyList]
  );

  return (
    <div className="container-fluid px-4">
      {/* ----- survey breadcrumb ------ */}
      <SurveyBreadCrumb />

      {/* ------ survey header ------ */}
      <SurveyHeader
        setDownloadExcel={setDownloadExcel}
        records={records}
        blockRefSelected={blockRefSelected}
      />

      <div className="table-responsive">
        <MaterialReactTable
          localization={mrtLocalization}
          columns={tableColumns}
          data={surveyList}
          globalFilterFn="includesString"
          enableSorting
          enableFilters
          enableGlobalFilter
          enableColumnFilterModes={false}
          muiTableHeadCellProps={{ title: "" }}
          enableGrouping
          enableColumnOrdering
          enableStickyHeader
          enableRowSelection
          onRowSelectionChange={setRowSelection}
          getRowId={(row) => row._id}
          state={{ rowSelection }}
          muiTableContainerProps={{ sx: { maxHeight: screenHeight - 50 } }}
          muiTableBodyRowProps={{ sx: { overflow: "visible" } }}
          muiTableBodyProps={{ sx: { overflow: "visible" } }}
          initialState={{
            pagination: { pageSize: 100, pageIndex: 0 },
            showColumnFilters: true,
          }}
        />
      </div>
    </div>
  );
};

export default SurveyListArea;
